import { c as _c } from "react/compiler-runtime";
import { CRM_BASE_API } from 'modules/crm/api/crm-pipeline-api';
import { ContactNoteInterface } from 'modules/crm/pipeline/contact-card/note/type/contact-note-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import useSWRInfinite from 'swr/infinite';
interface UseContactNotesProps extends SwrPaginationInterface {
  contactId: number | null;
  isFetchAllowed: boolean;
}
export const getNotesApi = (contactId: number | null) => `${CRM_BASE_API}/contacts/${contactId}/notes`;
export const useContactNotes = t0 => {
  const $ = _c(8);
  const {
    contactId,
    isFetchAllowed,
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== contactId || $[2] !== isFetchAllowed || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t2 = (pageIndex, previousPageData) => {
      if (!!previousPageData && !previousPageData.hasMore) {
        return null;
      }
      if (pageIndex === 0 && isFetchAllowed) {
        return `${getNotesApi(contactId)}?${getPaginationQueryString({
          limit,
          pagination
        })}`;
      }
      if (user && isFetchAllowed) {
        return `${getNotesApi(contactId)}?${getPaginationQueryString({
          limit,
          pagination: {
            ...pagination,
            startFromId: (pageIndex - 1) * limit + previousPageData.items.length
          }
        })}`;
      }
    };
    $[1] = contactId;
    $[2] = isFetchAllowed;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      revalidateAll: true
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useSWRInfinite(t2, fetcher, t3);
};